import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import sacBretellePetit from "@/assets/products/sac-bretelle-petit.png";
import sacBretelleGrand from "@/assets/products/sac-bretelle-grand.png";

const config: ProductPageConfig = {
  name: "Sacs bretelle",
  breadcrumbName: "Sacs bretelle",
  subtitle: "Sacs à bretelles résistants pour la vente à emporter",
  features: ["Résistant", "Pratique", "Disponible en stock"],
  variants: [
    { name: "Petit modèle", material: "Plastique", packaging: "Carton de 500 (10 x 50)", palette: "90 cartons", image: sacBretellePetit },
    { name: "Grand modèle", material: "Plastique", packaging: "Carton de 500 (10 x 50)", palette: "102 cartons", image: sacBretelleGrand },
  ],
};

const SacBretelle = () => <ProductPageLayout config={config} />;
export default SacBretelle;
